// src/pages/NotFoundPage.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen  flex flex-col items-center justify-center px-4">
      <div className="text-center max-w-md">
        {/* Big 404 */}
        <h1 className="text-8xl md:text-9xl font-bold text-primary/20 mb-4 select-none">
          404
        </h1>

        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Page Not Found
        </h2>

        <p className="text-muted-foreground mb-8 text-lg">
          Sorry, the page you are looking for doesn't exist or has been moved.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {/* <Button asChild size="lg" className="gap-2">
            <Link to="/">
              <Home className="h-5 w-5" />
              Go to Homepage
            </Link>
          </Button> */}

          <Button 
            variant="outline" 
            size="lg" 
            className="gap-2"
            onClick={() => navigate('/', { replace: true })}
            // className="bg-transparent hover:bg-primary/10 "
          >
            <ArrowLeft className="h-5 w-5" />
            Go Back
          </Button>
        </div>

        {/* Optional fun element
        <div className="mt-12 text-sm text-muted-foreground">
          <p>Looking for something else?</p>
          <Link to="/dashboard" className="text-primary hover:underline">
            Go to Dashboard
          </Link>
        </div> */}
      </div>
    </div>
  );
};

export default NotFoundPage;